import React, { useEffect, useState } from 'react';
import {
  MIGRATION_SIGN_IN_NOTICE,
  migrationSignInNoticeVisible,
  migrationSignInNoticeDelay,
} from '@crewmates/api-client-legacy';

export default function MigrationSignInNotice({ recoveryUrl = '/forget-password' }) {
  // The first server and browser render agree; the notice reads the clock after mount.
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let timer;
    const refresh = () => {
      window.clearTimeout(timer);
      const now = Date.now();
      setVisible(migrationSignInNoticeVisible(now));
      const delay = migrationSignInNoticeDelay(now);
      if (delay !== null) timer = window.setTimeout(refresh, delay);
    };
    refresh();
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', refresh);
    return () => {
      window.clearTimeout(timer);
      window.removeEventListener('focus', refresh);
      document.removeEventListener('visibilitychange', refresh);
    };
  }, []);
  if (!visible) return null;
  return <p role="status" style={{ padding: '12px', margin: '12px 0', background: '#eef4f9', color: '#23426e', borderRadius: '6px', fontSize: '14px' }}>{MIGRATION_SIGN_IN_NOTICE}{recoveryUrl && <> <a href={recoveryUrl} style={{ textDecoration: 'underline' }}>Forgot password?</a></>}</p>;
}
